import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import PageNav from "@/components/PageNav";

import Home from "@/pages/Home";
import PerformancePage from "@/pages/PerformancePage";
import EvPage from "@/pages/EvPage";
import WhyPage from "@/pages/WhyPage";
import GalleryPage from "@/pages/GalleryPage";
import SalesPage from "@/pages/SalesPage";
import GolfPage from "@/pages/GolfPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import NotFound from "@/pages/NotFound";

import { Toaster } from "@/components/ui/sonner";
import { GOLF_PARTNERSHIP_LIVE } from "@/config";

function App() {
  return (
    <div className="App min-h-screen bg-[var(--owrs-bg)] text-[var(--owrs-text)] flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/performance" element={<PerformancePage />} />
            <Route path="/ev" element={<EvPage />} />
            <Route path="/why" element={<WhyPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/sales" element={<SalesPage />} />
            <Route path="/sales/:vehicleId" element={<SalesPage />} />
            {GOLF_PARTNERSHIP_LIVE && <Route path="/golf" element={<GolfPage />} />}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <PageNav />
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0D1F2D",
            color: "#E5E2DC",
            border: "1px solid rgba(229,226,220,0.18)",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
